import { Col, Form, Row } from 'antd';
import { useEffect } from 'react';
import { convertDateStringtoMoment } from '../../../../../../../../utilz/dates';
import Button from '../../../../../../../components/Buttons/Button';
import EmptyRecords from '../../../../../../../components/Common/EmptyRecords';
import FormDatePicker from '../../../../../../../components/Inputs/FormDatePicker';
import FormInput from '../../../../../../../components/Inputs/FormInput';
import CommonModal from '../../../../../../../components/Modals/CommonModal';
import Paper from '../../../../../../../components/Paper/Paper';

const OverChargeUploadItemsModal = ({ open, setOpen, items = [], handleApply }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldValue(
      'items',
      items
        ? items.map((row) => ({
            ...row,
            shipDate: convertDateStringtoMoment(`${row.shipDate}Z`),
          }))
        : [],
    );
  }, [items]);

  const handleFormSubmit = (data) => {
    if (handleApply) {
      handleApply(data.items);
    }
  };

  return (
    <CommonModal className="w-95" open={open} title="Items Details" onClose={() => setOpen(false)} customFooter={<></>}>
      <Row className="h-100 overflow-hidden flex-direction-column">
        <Col className="flex-1 custom-scroll-bar pb-30">
          {items?.length === 0 ? (
            <EmptyRecords title="No items found!" descriptionOne="" descriptionTwo="" />
          ) : (
            <Form onFinish={handleFormSubmit} form={form}>
              <Form.List name="items">
                {(items) => (
                  <>
                    {items.map((item) => (
                      <ItemCard item={item} key={item.name} />
                    ))}
                  </>
                )}
              </Form.List>
            </Form>
          )}
        </Col>
        <Col>
          <Row justify="end" gutter={15}>
            <Col>
              <Button onClick={() => form.submit()}>Save</Button>
            </Col>
            <Col>
              <Button type="default" variant="danger" onClick={() => setOpen(false)}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </CommonModal>
  );
};

export default OverChargeUploadItemsModal;

const ItemCard = ({ item }) => {
  return (
    <Paper className="mb-15 px-15 pt-15" border>
      <Row gutter={10}>
        <Col sm={3}>
          <FormInput
            label="Freight Bill / Pro Number"
            placeholder="Enter Freight Bill / Pro Number"
            margin="mb-0"
            name={[item.key, 'proNo']}
            editMode
            rules={[
              {
                required: true,
                message: 'Please enter Freight Bill / Pro Number',
              },
            ]}
            maxLength={25}
          />
        </Col>
        <Col sm={3}>
          <FormDatePicker
            label="Ship Date"
            placeholder="Choose ship date"
            name={[item.key, 'shipDate']}
            editMode
            margin="m-0"
            rules={[
              {
                required: true,
                message: 'Please choose ship date',
              },
            ]}
          />
        </Col>
        <Col sm={2}>
          <FormInput
            label="Package Number"
            placeholder="Please enter package number"
            name={[item.key, 'packageNumber']}
            editMode
          />
        </Col>
        <Col sm={2}>
          <FormInput
            label="Invoice Number"
            placeholder="Please enter invoice number"
            name={[item.key, 'invoiceNumber']}
            editMode
          />
        </Col>
        <Col sm={2}>
          <FormInput
            label="Chargeable Weight"
            placeholder="Please enter chargeable weight"
            name={[item.key, 'weight']}
            editMode
            inputType="number"
          />
        </Col>
        <Col sm={2}>
          <FormInput
            label="Billed Amount"
            placeholder="Please enter billed amount"
            name={[item.key, 'billedAmount']}
            editMode
            inputType="number"
          />
        </Col>
        <Col sm={2}>
          <FormInput
            label="Paid Amount"
            placeholder="Please enter paid amount"
            name={[item.key, 'paidAmount']}
            editMode
            inputType="number"
          />
        </Col>
        <Col sm={2}>
          <FormInput
            label="Correct Charges"
            placeholder="Please enter correct charges"
            name={[item.key, 'correctCharges']}
            editMode
            inputType="number"
          />
        </Col>
        <Col sm={3}>
          <FormInput
            label="Overcharge Sum"
            placeholder="Please enter overcharge sum"
            name={[item.key, 'overchargeAmount']}
            editMode={false}
            inputType="number"
            margin="mb-15"
          />
        </Col>
        <Col sm={3}>
          <FormInput
            label="Recovery Sum"
            placeholder="Please enter recovery sum"
            name={[item.key, 'recoveryAmount']}
            editMode
            inputType="number"
          />
        </Col>
      </Row>
    </Paper>
  );
};
